module.exports = __webpack_public_path__ + "img/search-by-zip-honda.5f9d0cfa.png";